module.exports = __webpack_public_path__ + "images/videoCaseStudy-berriFit-whyus-photo-03.jpg?h=43bc399fb4cbe45d860efc40171035b3";


//////////////////
// WEBPACK FOOTER
// ./src/theme/images/videoCaseStudies/berriFit/videoCaseStudy-berriFit-whyus-photo-03.jpg
// module id = 2102
// module chunks = 12 15